<template>
  <div class="public_bg">
    <div class="nurse_top">
      <div style="height:54px;line-height:54px;">
        <img style="vertical-align:middle;" src="@/assets/beadhouse/juxing.png" />
        <span>护理计划</span>
      </div>
    </div>
    <div class="row_link clearfix">
      <div class="item" v-for="(item,index) in infoList" :key="index" @click="handleClick(item)">
        <a>
          <img :src="item.img" />
          <h5 style="font-size:16px;">{{item.title}}</h5>
          <span>{{item.text}}</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus";
export default {
  name: "CarePlanManage",
  data() {
    return {
      infoList: []
    };
  },
  methods: {
    handleClick(item) {
      bus.$emit("homePage", {
        type: "jump",
        path: item.url,
        title: item.title
      });
    },
    getPageData() {
      this.infoList = [
        {
          img: require("@/assets/beadhouse/banzhangrizhi.png"),
          title: "护理计划管理",
          text: "制定、查询、修改和终止护理计划",
          uid: 1,
          url: "/CarePlanList"
        },
        {
          img: require("@/assets/beadhouse/hugonghuli.png"),
          title: "护理项目管理",
          text: "维护机构护理服务项目",
          uid: 2,
          url: "/NursingProjectList"
        },
        {
          img: require("@/assets/beadhouse/bzpaibanjihua.png"),
          title: "护理模板管理",
          text: "按自理等级配置标准护理模板",
          uid: 3,
          url: "/NursingTemplateList"
        },
        {
          img: require("@/assets/beadhouse/GuardGroup.png"),
          title: "护理组管理",
          text: "护理团队、组长、区域与排班配置",
          uid: 4,
          url: "/NursingGroupManage"
        },
        {
          img: require("@/assets/beadhouse/CYpaibanjihua.png"),
          title: "护理任务管理",
          text: "计划生成任务、监控执行与打卡",
          uid: 5,
          url: "/NursingTaskManage"
        },
        {
          img: require("@/assets/beadhouse/CYhulirizhi.png"),
          title: "护理记录管理",
          text: "计划模块护理执行记录查询与管理",
          uid: 6,
          url: "/NursingRecordPrdManage"
        },
        {
          img: require("@/assets/beadhouse/BuildView.png"),
          title: "整合查看",
          text: "护理计划、记录、生活记录整合报告",
          uid: 7,
          url: "/NursingIntegrateView"
        },
        {
          img: require("@/assets/beadhouse/CYpinggujilu_btn.png"),
          title: "数据统计",
          text: "执行率、工作量、超时率统计分析",
          uid: 8,
          url: "/NursingStatsDashboard"
        },
        {
          img: require("@/assets/beadhouse/bzpaibanjihua.png"),
          title: "护理计费",
          text: "护理任务完成后的计费记录查询",
          uid: 9,
          url: "/NursingBillList"
        }
      ];
    }
  },
  created() {
    this.getPageData();
  }
};
</script>
<style lang="scss" scoped>
.public_bg {
  width: 100%;
  height: 95%;
  padding: 0 0 20px 0;
  background: #fefefe;
  .nurse_top {
    border: 1px #f1eff2 solid;
    background: #f9f7fa;
    position: relative;
    img {
      margin: 14px 12px;
    }
  }
  .row_link {
    width: 1259px;
    margin: 34px 35px;
    .item {
      width: 275px;
      height: 99px;
      border: #f0f0f2 1px solid;
      margin-bottom: 34px;
      margin-right: 34px;
      float: left;
      cursor: pointer;
      img {
        float: left;
        margin: 8px 23px 8px 33px;
        margin-right: 16px;
      }
      span {
        color: #666666;
      }
      h5 {
        margin-top: 21px;
        margin-bottom: 8px;
      }
      a:hover {
        color: #333;
      }
    }
    .item:hover {
      border: 1px solid red;
    }
  }
}
.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  visibility: hidden;
  clear: both;
}
.clearfix {
  *zoom: 1;
}
</style>
